import api from "./api.js";

export default class ColumnApi {
  static async getCategoryList(data) {
    return await api.get(`api/column-category`, data);
  }

  static async getList(data) {
    return await api.get(`api/column-post`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/column-post/${id}`, data);
  }

  static async putScrap(data) {
    return await api.patch(`api/column-scrap`, data);
  }

  static async commentList(data) {
    return await api.get(`api/column-comment`, data);
  }

  static async registerComment(data) {
    return await api.post(`api/column-comment`, data);
  }

  static async editComment(id, data) {
    return await api.patch(`api/column-comment/${id}`, data);
  }

  static async delComment(data) {
    return await api.del(`api/column-comment`, data);
  }
}
